import { JetView } from 'webix-jet'; // Importing JetView class from webix-jet framework
import { devConfig } from 'config/config'; // Importing development configuration from config module

/**
 * Represents a view for table types.
 * @extends JetView
 */
export default class tableTypesView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        // Retrieve the localization service and its translation function
        const _ = this.app.getService('locale')._;
        // Format date according to the application's date format configuration
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat);
        // Preserve the context of 'this' for use in inner functions
        var vthis = this;
        return {
            // Define a Webix datatable view
            view: 'datatable',
            // Unique identifier for the datatable
            id: 'datatableTyp',
            // CSS classes for styling the datatable borders
            css: 'webix_header_border webix_data_border webix_footer_border',
            // Enable row selection
            select: true,
            // Conditional vertical scrolling based on screen width
            scrollY: screen.width < 820 ? false : true,
            // Define the columns of the datatable
            columns: [
                {
                    // Column ID for rating
                    id: 'rating',
                    // Header for the column (empty in this case)
                    header: '',
                    // Width of the column
                    width: 50,
                    // Height of the column
                    height: 25,
                    // Tooltip text for the column header
                    tooltip: _('Editar'),
                    // Template function to render the column content
                    template: function (obj) {
                        // Check if the user has permission to edit
                        if (devConfig.getPermAction('accountingTypeCenterPositionEdit', 'Edit')) {
                            // Return an edit icon if permission is granted
                            return "<span class='webix_icon wxi-close edit'></span>";
                        } else {
                            // Return an empty string if permission is denied
                            return '';
                        }
                    },
                },
                // Column definition for ID
                { id: 'Id', header: 'ID', width: 60, sort: 'int' },
                // Column definition for Name with localization
                { id: 'Name', header: _('Nombre'), width: 150, sort: 'int' },
                // Column definition for Type with localization
                { id: 'Type', header: _('Tipo'), width: 150, sort: 'int' },
            ],
            // Event handler for click events on the edit icon
            onClick: {
                edit: function (euv, id) {
                    // Show the edit type dialog when the edit icon is clicked
                    $$('EditType').show();
                },
            },
            // Enable tooltips for the datatable
            tooltip: true,
            // Enable mathematical operations in the datatable
            math: true,
            // Load ahead configuration for data fetching
            loadahead: devConfig.getDefaultDataFetch(),
            // Pager ID for pagination controls
            pager: 'pagerA',
            // API URL for fetching data
            url: devConfig.geturlApi() + 'Accounting/GetTypes',
            // Initial data for the datatable
            data: [
                {
                    // Data entry for ID
                    Id: '01',
                    // Data entry for Name
                    Name: 'Centro',
                    // Data entry for Type
                    Type: '0',
                },
                {
                    // Data entry for ID
                    Id: '02',
                    // Data entry for Name
                    Name: 'Cargo',
                    // Data entry for Type
                    Type: '1',
                },
            ],
        }; // Placeholder for the configuration content of the view
    }

    /**
     * Initializes the view and its components.
     * @param {Object} grid - The grid component to be initialized.
     */
    init(grid) {
        // Retrieve the localization service from the app
        const _ = this.app.getService('locale')._;
        // Get the URL for the grid data
        var url = grid.data.url;
        // Initialize an empty filter string
        var filter = '';
        // Listen for 'type:filter' events on the app
        this.on(this.app, 'type:filter', (filterData) => {
            // Convert filterData object into an array of entries
            var object = Object.entries(filterData);
            // Initialize an empty string to build the query parameters
            var string1 = '';
            // Iterate over each entry in the filterData
            for (var i = 0; i < object.length; i++) {
                // Check if the value is not an object and not an empty string
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Handle 'CreatedLocalDate' filter
                    if (object[i][0] == 'CreatedLocalDate') {
                        var date = object[i][1].split(' - ');
                        // Append date range to the query string
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        // Handle 'ModifiedLocalDate' filter
                        if (object[i][0] == 'ModifiedLocalDate') {
                            var date = object[i][1].split(' - ');
                            // Append modified date range to the query string
                            string1 = string1 + '&dateFrom2=' + date[0];
                            string1 = string1 + '&dateTo2=' + date[1];
                        } else {
                            // Append other filters to the query string
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                        }
                    }
                } else {
                    // Handle cases where the value is an object
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]);
                        // Iterate over each entry in the nested object
                        for (var j = 0; j < object2.length; j++) {
                            // Check if the value is not null
                            if (object2[j][1] !== null) {
                                // Handle 'start' date
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]);
                                    // Format the start date for the query string
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    // Append start date to the query string
                                    string1 = string1 + '&' + dateFrom;
                                } else {
                                    // Handle 'end' date
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]);
                                        // Format the end date for the query string
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        // Append end date to the query string
                                        string1 = string1 + '&' + dateTo;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            // Clear the grid before loading new data
            grid.clearAll();
            // Load the grid with the constructed URL and query parameters
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1);
            // Update the filter variable with the current filter string
            filter = string1;
        });
        // Create a popup window for editing a type
        var popup = webix.ui({
            view: 'window', // Define the view type as a window
            id: 'EditType', // Unique identifier for the window
            head: {
                view: 'toolbar', // Toolbar at the top of the window
                cols: [
                    { view: 'label', label: _('Editar Tipo') }, // Label for the window title
                    {
                        view: 'icon', // Close icon in the toolbar
                        icon: 'wxi-close', // Icon type
                        click: function () {
                            // Click event to close the window
                            this.getTopParentView().hide(); // Hide the parent view (window)
                        },
                    },
                ],
            },
            position: 'center', // Center the window on the screen
            modal: true, // Make the window modal
            body: {
                view: 'form', // Form inside the window
                id: 'editForm', // Unique identifier for the form
                elements: [
                    { view: 'text', label: 'ID', name: 'Id', readonly: true }, // Read-only field for ID
                    { view: 'text', label: _('Nombre'), name: 'Name' }, // Input field for Name
                    {
                        view: 'text', // Input field for Type
                        label: _('Tipo'),
                        name: 'Type',
                        type: 'number', // Specify the input type as number
                        readonly: true, // Make the field read-only
                    },
                    {
                        cols: [
                            // Horizontal layout for buttons
                            {
                                view: 'button', // Cancel button
                                value: _('Cancelar'), // Button label
                                click: function () {
                                    // Click event for cancel button
                                    this.getTopParentView().hide(); // Hide the parent view (window)
                                   $$('editForm').setValues(
                                        // Reset form values
                                       $$('editForm').getCleanValues(),
                                    );
                                },
                            },
                            {
                                view: 'button', // Save button
                                type: 'form', // Specify button type as form
                                value: _('Guardar'), // Button label
                                click: function ($e) {
                                    // Click event for save button
                                    var values =$$('editForm').getValues(); // Get form values
                                    webix
                                        .ajax() // Perform an AJAX request
                                        .headers({
                                            'Content-type': 'application/json', // Set content type to JSON
                                        })
                                        .post(
                                            devConfig.geturlApi() + // API URL for the request
                                                'Accounting/Type',
                                            '{"Id":"' + // JSON payload for the request
                                                values.Id +
                                                '", "Name":"' +
                                                values.Name +
                                                '", "Type":"' +
                                                values.Type +
                                                '"}',
                                            {
                                                error: function (
                                                    // Error callback
                                                    text,
                                                    data,
                                                    XmlHttpRequest,
                                                ) {
                                                    webix.message(_('Error! ')); // Show error message
                                                },
                                                success: function (
                                                    // Success callback
                                                    text,
                                                    data,
                                                    XmlHttpRequest,
                                                ) {
                                                    webix.message(_('Tipo Actualizado')); // Show success message
                                                    grid.clearAll(); // Clear the grid data
                                                    grid.load(
                                                        // Reload the grid with updated data
                                                        url + '?start=0&count=' + grid.data.$pagesize + filter,
                                                    );
                                                },
                                            },
                                        );
                                   $$('editForm').setValues(
                                        // Reset form values after submission
                                       $$('editForm').getCleanValues(),
                                    );
                                    this.getTopParentView().hide(); // Hide the parent view (window)
                                },
                            },
                        ],
                    },
                ],
            },
        });
        // Create a popup window for adding a new type
        var popupAdd = webix.ui({
            view: 'window', // Define the view type as a window
            id: 'AddType', // Unique identifier for the window
            head: {
                // Header section of the window
                view: 'toolbar', // Define the header as a toolbar
                cols: [
                    // Columns within the toolbar
                    { view: 'label', label: _('Añadir Tipo') }, // Label for the window
                    {
                        view: 'icon', // Icon button to close the window
                        icon: 'wxi-close', // Icon type
                        click: function () {
                            // Click event to hide the window
                            this.getTopParentView().hide(); // Hide the top parent view (the window)
                        },
                    },
                ],
            },
            position: 'center', // Center the window on the screen
            modal: true, // Make the window modal
            body: {
                // Body section of the window
                view: 'form', // Define the body as a form
                id: 'addform', // Unique identifier for the form
                elements: [
                    // Form elements
                    {
                        view: 'text', // Text input for the name
                        label: _('Nombre'), // Label for the input
                        name: 'Name', // Name attribute for the input
                        required: true, // Mark as required
                    },
                    {
                        view: 'text', // Text input for the type
                        label: _('Tipo'), // Label for the input
                        name: 'Type', // Name attribute for the input
                        type: 'number', // Specify input type as number
                        required: true, // Mark as required
                    },
                    {
                        cols: [
                            // Columns for buttons
                            {
                                view: 'button', // Button for cancel action
                                value: _('Cancelar'), // Button label
                                click: function () {
                                    // Click event to hide the window and reset form
                                    this.getTopParentView().hide(); // Hide the top parent view (the window)
                                    $$('addform').setValues(
                                        // Reset form values
                                        $$('addform').getCleanValues(), // Get clean values to reset
                                    );
                                },
                            },
                            {
                                view: 'button', // Button for save action
                                type: 'form', // Specify button type as form
                                value: _('Guardar'), // Button label
                                click: function ($e) {
                                    // Click event to save form data
                                    var values = $$('addform').getValues(); // Get form values
                                    if ($$('addform').validate()) {
                                        // Validate form
                                        webix // Perform AJAX request to save data
                                            .ajax()
                                            .headers({
                                                'Content-type': 'application/json', // Set content type for request
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'Accounting/Type', // API endpoint
                                                '{"Name":"' + values.Name + '", "Type":"' + values.Type + '"}', // JSON payload
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        // Error callback
                                                        webix.message(_('Error! ')); // Show error message
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        // Success callback
                                                        webix.message(_('Tipo Agregado')); // Show success message
                                                        grid.clearAll(); // Clear the grid data
                                                        grid.load(
                                                            // Reload the grid with new data
                                                            url + '?start=0&count=' + grid.data.$pagesize + filter,
                                                        );
                                                    },
                                                },
                                            );
                                        $$('addform').setValues(
                                            // Reset form values after submission
                                            $$('addform').getCleanValues(),
                                        );
                                        this.getTopParentView().hide(); // Hide the window after submission
                                    } else {
                                        webix.message({
                                            // Show alert if validation fails
                                            title: _('¡Error!'),
                                            type: 'alert-error',
                                            text: _('Completa los campos...'), // Prompt to complete fields
                                        });
                                    }
                                },
                            },
                        ],
                    },
                ],
                elementsConfig: {
                    // Configuration for form elements
                    on: {
                        onChange: function () {
                            // Event triggered on change
                            this.validate(); // Validate the form on change
                        },
                    },
                },
            },
        });
       $$('editForm').bind($$('datatableTyp')); // Binds the edit form to the data table for synchronization.
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Attaches an event handler for after sorting the grid.
            grid.load(
                // Loads data into the grid after sorting.
                url + // Base URL for data fetching.
                    '?start=0&count=' + // Pagination parameters.
                    grid.data.$pagesize + // Current page size from grid data.
                    filter + // Additional filter parameters.
                    '&sort[' + // Sort parameters.
                    by + // Column to sort by.
                    ']=' +
                    dir, // Direction of sorting (ascending/descending).
            );
        });
        this.on(this.app, 'addType:button', (filter) => {
            // Listens for the 'addType:button' event on the application.
            $$('addform').clearValidation(); // Clears any validation messages on the add form.
            popupAdd.show(); // Displays the popup for adding a new type.
        }); // Placeholder for the initialization content of the view
    }
}

// FILE DOCUMENTED
